<!-- TODO: Newer Report Run Banner -->
<!-- TODO: External Share Banner -->
<!-- TODO: Parameters Component -->
<!-- TODO: Filter Component -->
<div class="report-layout-container" *ngIf="reportReady$ | async; else loading">
  <div class="mode-header">
    <h1>{{ (reportReady$ | async).name ?? 'Untitled Report' }}</h1>
    <p class="report-description">{{ (reportReady$ | async).description }}</p>
  </div>
  <ng-container *ngIf="reportGrid$ | async as grids">
    <div *ngFor="let grid of grids" class="mode-grid">
      <div *ngFor="let row of grid.rows" class="mode-row">
        <div
          *ngFor="let col of row.columns"
          [class]="'col-' + col.height + '-' + col.width"
        >
          <mode-viz
            [token]="col.vizToken"
            [height]="row.height"
            [title]="chartFacade.createChartTitleFromVizToken(col.vizToken) | async"
            [chartType]="chartFacade.createChartTypeFromVizToken(col.vizToken) | async"
            [queryToken$]="chartFacade.createQueryTokenFromVizToken(col.vizToken)"
            [encoding]="chartFacade.createEncodingFromVizToken(col.vizToken) | async"
            [format]="chartFacade.createChartFormatFromVizToken(col.vizToken) | async"
            [fieldFormats]="chartFacade.createChartFieldFormatMapFromVizToken(col.vizToken) | async"
            [fieldColors]="chartFacade.createChartFieldColorMapFromVizToken(col.vizToken) | async"
            [facetSizes]="chartFacade.createChartFacetSizeMapFromVizToken(col.vizToken) | async"
            [reportLevelColorMap]="{}"
            (chartLoaded)="renderEnd($event)"
          ></mode-viz>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #loading>
  <mode-loader class="report-loading">
  </mode-loader>
</ng-template>
